import { DataTable } from "../../data-table.interface";

export const dailyDispatchCapacityFood: DataTable = {
  searchText: "",
  export: false,
  filter: false,
  checkbox: true,
  show: "Aun no hay capacidades que mostrar",
  iconsOfActions: [
    {
      icon: "cancel",
      tooltip: "Eliminar capacidad",
    },
    {
      icon: "edit",
      tooltip: "Editar capacidad",
      hasVisibleCondition: (element: any[]): boolean => {
        return element && element.length && element.length <= 1 ? true : false;
      },
    },
    {
      icon: "exception-days",
      tooltip: "Agregar excepción",
    },
    {
      icon: "calendar",
      tooltip: "Agregar excepción de feriados",
    },
  ],
  columns: [
    {
      title: "Nº Despachos",
      name: "capacityValue",
      type: "string",
      class: "left",
      value: (element: any) => element.capacityValue,
    },
    {
      title: "Rango horario",
      name: "timeRange",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.timeRangeFrom != null
          ? element.timeRangeFrom + " a " + element.timeRangeTo
          : "",
    },
    {
      title: "Hora de corte",
      name: "cutTime",
      type: "string",
      class: "left",
      value: (element: any) => element.cutTime
    },
    {
      title: "Hora y minuto de bloqueo",
      name: "blockingTime",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.blockingHour != null &&
        element.blockingMinute &&
        element.blockingMinute.id != null
          ? element.blockingHour + ":" + element.blockingMinute.value
          : element.blockingHour != null && element.blockingMinute != null
          ? element.blockingHour.toString() +
            ":" +
            element.blockingMinute.toString()
          : null,
    },
    {
      title: "Códigos Vtex",
      name: "vtexCodeList",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.vtexCodeList && element.vtexCodeList.length > 0
          ? element.vtexCodeList.map((item) => item.vtexCode)
          : "",
    },
    {
      title: "Tiene excepciones",
      name: "exception",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.capacityException && element.capacityException.length > 0
          ? "SI"
          : "NO",
    },
  ],
};
